export const ColunasLevantamentoQuantitativo: string[] = [
    'bairro',
    'cbo',
    'cbodescricao',
    'cep',
    'cidade',
    'classesocial',
    'escolaridade',
    'estadocivil',
    'idade',
    'macrorregiao',
    'mesorregiao',
    'microrregiao',
    'scorecreditodescricao',
    'sexo',
    'signo',
    'situacaocadastral',
    'uf'
]